const countryCodes = [
  { code: 93, value: 'Afghanistão - 93' },
  { code: 27, value: 'África do Sul - 27' },
  { code: 355, value: 'Albânia - 355' },
  { code: 49, value: 'Alemanha - 49' },
  { code: 376, value: 'Andora - 376' },
  { code: 244, value: 'Angola - 244' },
  { code: 1264, value: 'Anguilla - 1 264' },
  { code: 672, value: 'Antarctica - 672' },
  { code: 1268, value: 'Antígua e Barbuda - 1 268' },
  { code: 54, value: 'Argentina - 54' },
  { code: 213, value: 'Argélia - 213' },
  { code: 374, value: 'Arménia - 374' },
  { code: 297, value: 'Aruba - 297' },
  { code: 966, value: 'Arábia Saudita - 966' },
  { code: 61, value: 'Austrália - 61' },
  { code: 43, value: 'Áustria - 43' },
  { code: 994, value: 'Azerbaijão - 994' },
  { code: 1242, value: 'Bahamas - 1 242' },
  { code: 973, value: 'Bahrein - 973' },
  { code: 880, value: 'Bangladesh - 880' },
  { code: 1246, value: 'Barbados - 1 246' },
  { code: 32, value: 'Bélgica - 32' },
  { code: 501, value: 'Belize - 501' },
  { code: 229, value: 'Benim - 229' },
  { code: 1441, value: 'Bermuda - 1 441' },
  { code: 975, value: 'Butão - 975' },
  { code: 375, value: 'Bielorrússia - 375' },
  { code: 591, value: 'Bolívia - 591' },
  { code: 387, value: 'Bósnia e Herzegovina - 387' },
  { code: 267, value: 'Botswana - 267' },
  { code: 55, value: 'Brasil - 55' },
  { code: 0, value: 'British Indian Ocean Territory' },
  { code: 673, value: 'Brunei - 673' },
  { code: 359, value: 'Bulgária - 359' },
  { code: 226, value: 'Burkina Faso - 226' },
  { code: 95, value: 'Myanmar (Burma) - 95' },
  { code: 257, value: 'Burundi - 257' },
  { code: 237, value: 'Camarões - 237' },
  { code: 238, value: 'Cabo Verde - 238' },
  { code: 855, value: 'Camboja - 855' },
  { code: 1, value: 'Canadá - 1' },
  { code: 974, value: 'Catar - 974' },
  { code: 235, value: 'Chad - 235' },
  { code: 56, value: 'Chile - 56' },
  { code: 86, value: 'China - 86' },
  { code: 357, value: 'Chipre - 357' },
  { code: 6100, value: 'Christmas Island - 6100' },
  { code: 65, value: 'Cingapura - 65' },
  { code: 57, value: 'Colômbia - 57' },
  { code: 269, value: 'Comores - 269' },
  { code: 850, value: 'Coreia do Norte - 850' },
  { code: 82, value: 'Coreia do Sul - 82' },
  { code: 225, value: 'Costa do Marfim - 225' },
  { code: 506, value: 'Costa Rica - 506' },
  { code: 385, value: 'Croácia - 385' },
  { code: 53, value: 'Cuba - 53' },
  { code: 45, value: 'Dinamarca - 45' },
  { code: 253, value: 'Djibouti - 253' },
  { code: 1767, value: 'Dominica - 1 767' },
  { code: 20, value: 'Egito - 20' },
  { code: 503, value: 'El Salvador - 503' },
  { code: 971, value: 'Emirados Árabes Unidos - 971' },
  { code: 593, value: 'Equador - 593' },
  { code: 291, value: 'Eritreia - 291' },
  { code: 372, value: 'Estónia - 372' },
  { code: 34, value: 'Espanha - 34' },
  { code: 251, value: 'Etiópia - 251' },
  { code: 679, value: 'Fiji - 679' },
  { code: 358, value: 'Finlândia - 358' },
  { code: 33, value: 'França - 33' },
  { code: 241, value: 'Gabão - 241' },
  { code: 220, value: 'Gâmbia - 220' },
  { code: 970, value: 'Banda de Gaza (Palestina) - 970' },
  { code: 995, value: 'Geórgia - 995' },
  { code: 233, value: 'Gana - 233' },
  { code: 350, value: 'Gibraltar - 350' },
  { code: 30, value: 'Grécia - 30' },
  { code: 299, value: 'Groelândia - 299' },
  { code: 1473, value: 'Granada - 1 473' },
  { code: 1671, value: 'Guam - 1 671' },
  { code: 502, value: 'Guatemala - 502' },
  { code: 592, value: 'Guiana - 592' },
  { code: 224, value: 'Guiné - 224' },
  { code: 240, value: 'Guiné Equatorial - 240' },
  { code: 245, value: 'Guiné-Bissau - 245' },
  { code: 509, value: 'Haiti - 509' },
  { code: 504, value: 'Honduras - 504' },
  { code: 852, value: 'Hong Kong - 852' },
  { code: 36, value: 'Hungria - 36' },
  { code: 354, value: 'Islândia - 354' },
  { code: 1345, value: 'Ilhas Cayman - 1 345' },
  { code: 610, value: 'Ilhas Cocos (Keeling) - 610' },
  { code: 440, value: 'Ilha de Man - 440' },
  { code: 682, value: 'Ilhas Cook - 682' },
  { code: 500, value: 'Ilhas Falkland (Malvinas) - 500' },
  { code: 298, value: 'Ilhas Feroé - 298' },
  { code: 1670, value: 'Ilhas Mariana do Norte - 1 670' },
  { code: 692, value: 'Ilhas Marshall - 692' },
  { code: 6720, value: 'Ilhas Norfolk - 6720' },
  { code: 870, value: 'Ilhas Pitcairn - 870' },
  { code: 677, value: 'Ilhas Salomão - 677' },
  { code: 1649, value: 'Ilhas Turcas e Caicos - 1 649' },
  { code: 1340, value: 'Ilhas Virgens Americanas - 1 340' },
  { code: 1284, value: 'Ilhas Virgens Britânicas - 1 284' },
  { code: 91, value: 'India - 91' },
  { code: 62, value: 'Indonésia - 62' },
  { code: 44, value: 'Inglaterra (Reino Unido) - 44' },
  { code: 98, value: 'Irã - 98' },
  { code: 964, value: 'Iraque - 964' },
  { code: 353, value: 'Irlanda - 353' },
  { code: 972, value: 'Israel - 972' },
  { code: 39, value: 'Itália - 39' },
  { code: 1876, value: 'Jamaica - 1 876' },
  { code: 81, value: 'Japão - 81' },
  { code: 10000, value: 'Jersey - 00' },
  { code: 962, value: 'Jordânia - 962' },
  { code: 7, value: 'Cazaquistão - 7' },
  { code: 254, value: 'Quénia (Kenya) - 254' },
  { code: 686, value: 'Kiribati - 686' },
  { code: 381, value: 'Kosovo - 381' },
  { code: 965, value: 'Kuwait - 965' },
  { code: 996, value: 'Quirguistão - 996' },
  { code: 856, value: 'Laos - 856' },
  { code: 371, value: 'Letônia - 371' },
  { code: 961, value: 'Líbano - 961' },
  { code: 266, value: 'Lesoto - 266' },
  { code: 231, value: 'Libéria - 231' },
  { code: 218, value: 'Líbia - 218' },
  { code: 423, value: 'Liechtenstein - 423' },
  { code: 370, value: 'Lituânia - 370' },
  { code: 352, value: 'Luxemburgo - 352' },
  { code: 853, value: 'Macau - 853' },
  { code: 389, value: 'Macedónia - 389' },
  { code: 261, value: 'Madagáscar - 261' },
  { code: 265, value: 'Malawi - 265' },
  { code: 60, value: 'Malásia - 60' },
  { code: 960, value: 'Maldivas - 960' },
  { code: 223, value: 'Mali - 223' },
  { code: 356, value: 'Malta - 356' },
  { code: 222, value: 'Mauritânia - 222' },
  { code: 230, value: 'Maurícia - 230' },
  { code: 262, value: 'Mayotte - 262' },
  { code: 52, value: 'México - 52' },
  { code: 691, value: 'Micronésia - 691' },
  { code: 373, value: 'Moldávia - 373' },
  { code: 377, value: 'Monaco - 377' },
  { code: 976, value: 'Mongólia - 976' },
  { code: 382, value: 'Montenegro - 382' },
  { code: 1664, value: 'Montserrat - 1 664' },
  { code: 212, value: 'Marrocos - 212' },
  { code: 258, value: 'Moçambique - 258' },
  { code: 264, value: 'Namíbia - 264' },
  { code: 674, value: 'Nauru - 674' },
  { code: 977, value: 'Nepal - 977' },
  { code: 599, value: 'Netherlands Antilles - 599' },
  { code: 687, value: 'Nova Caledônia - 687' },
  { code: 64, value: 'Nova Zelândia - 64' },
  { code: 505, value: 'Nicaragua - 505' },
  { code: 227, value: 'Níger - 227' },
  { code: 234, value: 'Nigéria - 234' },
  { code: 683, value: 'Niue - 683' },
  { code: 47, value: 'Noruega - 47' },
  { code: 968, value: 'Omã - 968' },
  { code: 31, value: 'Países Baixos - 31' },
  { code: 92, value: 'Paquistão - 92' },
  { code: 680, value: 'Palau - 680' },
  { code: 507, value: 'Panamá - 507' },
  { code: 675, value: 'Papua-Nova Guiné - 675' },
  { code: 595, value: 'Paraguai - 595' },
  { code: 51, value: 'Peru - 51' },
  { code: 63, value: 'Filipinas - 63' },
  { code: 48, value: 'Polónia - 48' },
  { code: 689, value: 'Polinésia Francesa - 689' },
  { code: 351, value: 'Portugal - 351' },
  { code: 101, value: 'Porto Rico - 101' },
  { code: 242, value: 'República do Congo - 242' },
  { code: 243, value: 'República Democrática do Congo - 243' },
  { code: 236, value: 'República Centro-Africana - 236' },
  { code: 420, value: 'República Checa - 420' },
  { code: 1809, value: 'República Dominicana - 1 809' },
  { code: 40, value: 'Roménia - 40' },
  { code: 250, value: 'Ruanda - 250' },
  { code: 707, value: 'Rússia - 707' },
  { code: 590, value: 'Saint Barthelemy - 590' },
  { code: 685, value: 'Samoa - 685' },
  { code: 1684, value: 'Samoa Americana - 1 684' },
  { code: 378, value: 'San Marino - 378' },
  { code: 239, value: 'Sao Tome e Principe - 239' },
  { code: 221, value: 'Senegal - 221' },
  { code: 3810, value: 'Serbia - 3810' },
  { code: 232, value: 'Serra Leoa - 232' },
  { code: 248, value: 'Seychelles - 248' },
  { code: 421, value: 'Slovakia - 421' },
  { code: 386, value: 'Slovenia - 386' },
  { code: 252, value: 'Somalia - 252' },
  { code: 94, value: 'Sri Lanka - 94' },
  { code: 290, value: 'Saint Helena - 290' },
  { code: 1869, value: 'Saint Kitts and Nevis - 1 869' },
  { code: 1758, value: 'Saint Lucia - 1 758' },
  { code: 1599, value: 'Saint Martin - 1 599' },
  { code: 508, value: 'Saint Pierre and Miquelon - 508' },
  { code: 1784, value: 'Saint Vincent and the Grenadines - 1784' },
  { code: 249, value: 'Sudão - 249' },
  { code: 597, value: 'Suriname - 597' },
  { code: 268, value: 'Suazilândia - 268' },
  { code: 46, value: 'Suécia - 46' },
  { code: 41, value: 'Suiça - 41' },
  { code: 963, value: 'Syria - 963' },
  { code: 886, value: 'Taiwan - 886' },
  { code: 992, value: 'Tajiquistão - 992' },
  { code: 255, value: 'Tanzânia - 255' },
  { code: 670, value: 'Timor-Leste - 670' },
  { code: 66, value: 'Tailândia - 66' },
  { code: 228, value: 'Togo - 228' },
  { code: 690, value: 'Tokelau - 690' },
  { code: 676, value: 'Tonga - 676' },
  { code: 1868, value: 'Trinidad e Tobago - 1 868' },
  { code: 216, value: 'Tunísia - 216' },
  { code: 993, value: 'Turquemenistão - 993' },
  { code: 90, value: 'Turquia - 90' },
  { code: 688, value: 'Tuvalu - 688' },
  { code: 256, value: 'Uganda - 256' },
  { code: 380, value: 'Ucrânia - 380' },
  { code: 598, value: 'Uruguai - 598' },
  { code: 111, value: 'Estados Unidos (EUA) - 111' },
  { code: 998, value: 'Uzbequistão - 998' },
  { code: 678, value: 'Vanuatu - 678' },
  { code: 390, value: 'Vaticano - 390' },
  { code: 58, value: 'Venezuela - 58' },
  { code: 84, value: 'Vietnã (Vietname) - 84' },
  { code: 681, value: 'Wallis e Futuna - 681' },
  { code: 9700, value: 'West Bank - 9700' },
  { code: 1000, value: 'Western Sahara - 000' },
  { code: 967, value: 'Iémen (Iémen, Yemen) - 967' },
  { code: 263, value: 'Zimbabwe(Zimbabué) - 263' },
  { code: 260, value: 'Zâmbia - 260' }
]

export default countryCodes